module.exports = __webpack_public_path__ + "static/media/ke.549ee4aa.svg";